import styled from "styled-components";

export const CourierStatsWrapper = styled.div`
    position: absolute;
    background: #ffffffe3;
    z-index: 3;
    bottom: 0px;
    right: 0px;
    padding: 15px;
    padding-right: 30px;
    border-radius: 4px;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    max-height: 100px;
    min-width: 200px;
    overflow-y: scroll;
    scroll-behavior: smooth;
    transition: max-height 0.5s;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    &:hover,
    &:focus,
    &:active {
        transition: max-height 0.5s;
        max-height: 400px;
    }
`;

export const PoolShiftWrapper = styled.div`
    position: absolute;
    background: #ffffffe3;
    z-index: 3;
    bottom: 0;
    right: 0px;
    left: auto;
    padding: 15px;
    padding-right: 30px;
    border-radius: 4px;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    min-width: 200px;
    max-width: ${props => (props.isMobile ? "400px" : "50%")};
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    transition: bottom 0.3s ease-in-out;
`;

export const ToggleButton = styled.div`
    position: absolute;
    top: -30px;
    right: 30px;
    background: #ffffffe3;
    padding: 5px 15px;
    border-radius: 4px 4px 0 0;
    cursor: pointer;
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 500;
    z-index: 4;

    &:hover {
        background: #f5f5f5;
    }
`;

export const CourierStatsRow = styled.div`
    color: ${props => {
        if (props.status === "available") return "green";
        if (props.status === "unavailable") return "red";
        if (props.status === "onDelivery") return "orange";
        return "initial";
    }};
    font-weight: normal;
    padding: 2px 0;

    & > a {
        color: ${props => {
            if (props.status === "available") return "green";
            if (props.status === "unavailable") return "red";
            if (props.status === "onDelivery") return "orange";
            return "initial";
        }};
        font-weight: 500;
    }

    transition: background-color 0.5s;

    &:hover {
        background-color: #f0f0f0;
    }
`;

export const TableContainer = styled.div`
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: auto;
    background: white;
    border-radius: 8px;
    padding: 12px;
    position: relative;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    display: ${props => (props.isCollapsed ? "none" : "block")};
`;

export const StatsTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
`;

export const TableHeader = styled.thead`
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    tr {
        border-bottom: 2px solid #f0f0f0;
    }
`;

export const TableHeaderCell = styled.th`
    text-align: ${props => props.align || "left"};
    padding: 8px;
    min-width: ${props => props.minWidth || "60px"};
    max-width: ${props => props.maxWidth || "100px"};
    background-color: white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const HeaderContent = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
    border-bottom: 1px solid #f0f0f0;
    &:hover {
        background-color: #fafafa;
    }
`;

export const TableCell = styled.td`
    padding: 8px;
    text-align: ${props => props.align || "left"};
    font-weight: ${props => (props.bold ? 500 : "normal")};
    color: ${props => {
        switch (props.type) {
            case "available":
                return "green";
            case "unavailable":
                return "red";
            case "onDelivery":
                return "orange";
            default:
                return "inherit";
        }
    }};
`;
